// components
import { CenterPageTemplate } from '@/pwa/templates/CenterPageTemplate/CenterPageTemplate';
import { FloatingContent } from '@/pwa/molecules/FloatingContent/FloatingContent';

export interface ClientReferralSentPageProps {
  firstName: string;
  lastName: string;
  email: string;
  onInviteAnother: () => void;
  onDone: () => void;
}

export const ClientReferralSentPage = ({
  firstName,
  lastName,
  email,
  onInviteAnother,
  onDone,
}: ClientReferralSentPageProps) => {
  return (
    <CenterPageTemplate>
      <FloatingContent
        title='Referral Sent Successfully'
        description={`An invitation email has been sent to ${firstName} ${lastName} at ${email} with a magic link to get started.`}
        actions={[
          {
            label: 'Invite Another Client',
            variant: 'primary',
            onClick: onInviteAnother,
          },
          {
            label: 'Back To Dashboard',
            variant: 'secondary',
            onClick: onDone,
          },
        ]}
      />
    </CenterPageTemplate>
  );
};

ClientReferralSentPage.displayName = 'ClientReferralSentPage';
export default ClientReferralSentPage;
